import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=ba14f9c0&scoped=true&"
import script from "./SmallCard.vue?vue&type=script&lang=ts&"
export * from "./SmallCard.vue?vue&type=script&lang=ts&"
import style0 from "./SmallCard.vue?vue&type=style&index=0&id=ba14f9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba14f9c0",
  null
  
)

export default component.exports